/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DeclineOfferResponse = {
    outcome: DeclineOfferResponse.outcome;
};

export namespace DeclineOfferResponse {

    export enum outcome {
        SUCCESS = 'success',
        EXPIRED = 'expired',
        UNAUTHORIZED = 'unauthorized',
    }


}

